import { render, staticRenderFns } from "./AddClientModal.vue?vue&type=template&id=f9943260&scoped=true&class=fill-height"
import script from "./AddClientModal.vue?vue&type=script&lang=ts"
export * from "./AddClientModal.vue?vue&type=script&lang=ts"
import style0 from "./AddClientModal.vue?vue&type=style&index=0&id=f9943260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9943260",
  null
  
)

export default component.exports